<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :batch-actions="batchActions"
    :form="form"
    :title="$t('model.event')"
    namespace=""
    resource="events"
    :actionColumnProps="{ width: 160 }"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import { filterColumnsHash, columnsHash, formColumnsHash } from '../admin_configs/events/columns';

@Component
export default class Events extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      { prop: 'title_cont' },
    ].filter(Boolean).map(hash => _.merge(filterColumnsHash[hash['prop']], hash))
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    return [
      { prop: 'id' },
      { prop: 'title' },
      { prop: 'event_category_id' },
      { prop: 'start_at' },
      { prop: 'end_at' },
      { prop: 'address' },
      type === 'show' && {
        prop: 'mini_program_path',
        label: this.$t('event.miniProgramPath'),
      },
      type === 'show' && { prop: 'images' },
      type === 'show' && { prop: 'description' },
      type === 'show' && { prop: 'created_at' },
      type === 'show' && { prop: 'updated_at' },
    ].filter(Boolean).map(hash => _.merge(columnsHash[hash['prop']], hash))
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { type }) {
    return [
      { prop: 'title' },
      { prop: 'event_category_id' },
      {
        prop: 'start_at',
        renderCell: {
          hint: this.$t('hints.disallowEditAfterCreate'),
          props: {
            disabled: type === 'edit',
          }
        }
      },
      {
        prop: 'end_at',
        renderCell: {
          hint: this.$t('hints.disallowEditAfterCreate'),
          props: {
            disabled: type === 'edit',
          }
        }
      },
      { prop: 'address' },
      { prop: 'description' },
      {
        prop: 'images',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 750x422`,
          props: {
            limit: 9,
            cropper: {
              width: 750,
              height: 422
            }
          }
        }
      }
    ].filter(Boolean).map(hash => _.merge(formColumnsHash[hash['prop']], hash))
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'events.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'events.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
   * @param {Object} scope -表格 scope 数据
   * @param {Object} scope.selection - 表格已选择行数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  batchActions() {
  // batchActions({ selection }, { remove, reload }) {
    return [
      // () => <el-button onClick={() => console.log(selection)}>批处理({ selection.length })</el-button>
    ];
  }

}


export const route = [
  {
    path: '/events',
    name: 'events.index',
    component: Events,
    props: {
      type: 'index',
    }
  },
  {
    path: '/events/new',
    name: 'events.new',
    component: Events,
    props: {
      type: 'new',
    }
  },
  {
    path: '/events/:id',
    name: 'events.show',
    component: Events,
    props: {
      type: 'show',
    }
  },
  {
    path: '/events/:id/edit',
    name: 'events.edit',
    component: Events,
    props: {
      type: 'edit'
    }
  }
]
</script>
